export default function EmptyState({ icon: Icon, title, description, action, testid = "empty-state" }) {
    return (
        <div data-testid={testid} className="flex flex-col items-center justify-center text-center py-16 px-6">
            {Icon ? (
                <div className="w-14 h-14 rounded-2xl bg-indigo-50 text-indigo-600 grid place-items-center mb-4">
                    <Icon className="w-6 h-6" />
                </div>
            ) : null}
            <h3 className="font-display text-lg font-bold text-slate-900 mb-1.5">{title}</h3>
            {description ? <p className="text-sm text-slate-500 max-w-sm mb-5">{description}</p> : null}
            {action}
        </div>
    );
}
